<template>
  <auth-layout>
    <div>
      <h3 class="fw-bold text-uppercase mb-2">Recupera tu cuenta</h3>
      <p class="mb-4">
        Te enviaremos un correo electrónico con instrucciones para restablecer tu contraseña.
      </p>
    </div>

    <div
      class="alert alert-danger"
      role="alert"
      v-if="hasError"
    >
      {{ msg }}.
    </div>

    <form @submit.prevent="ForgottenPassword">
      <!-- Username Input -->
      <username-input
        id="username"
        name="username"
        autocomplete="username"
        v-model="form.employee_code"                
        placeholder="No Empleado"
        :class="{ 'is-invalid': hasError }"
      />

      <button
        type="submit"
        class="btn btn-portal btn-lg w-100 text-uppercase mt-3"
      >
        Aceptar
      </button>

      <div class="mt-3 text-center">
        <router-link :to="{ name: 'SignIn' }" class="buzonColor">
          Ir a login
        </router-link>
      </div>
    </form>
  </auth-layout>
</template>

<script>
import axios from "axios";
import AuthLayout from "@/template/AuthLayout.vue";
import UsernameInput from './components/UsernameInput.vue';

export default {
  name: "ForgottenPassword",
  components: {
    AuthLayout,
    UsernameInput
  },
  data() {
    return {
      hasError: false,
      msg: null,
      form: {
        employee_code: "",
      },
    };
  },
  methods: {
    ForgottenPassword() {
      axios
        .post("forgottenPassword", {
          data: this.form,
        })
        .then((response) => {
          this.$swal({
            title: response.data,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.replace({
                name: "SignIn",
              });
            }
          });
        })
        .catch(() => {
          this.msg = "Código de empleado erróneo.";
          this.hasError = true;
          setTimeout(() => {
            this.hasError = false;
          }, 5000);
          this.form.password = null;
        });
    },
  },
};
</script>

<style scoped></style>
